export default __webpack_public_path__ + "static/media/chevron-down-right.f8d6d1b7.svg";